import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";

import moment from "moment";
import Grid from "@material-ui/core/Grid";

import Header from "../../components/Header";
import Firebase from "../../firebasehelper";

import "./index.css";

const default_avatar = require("../../assets/media/user.png");

const CommunityRegistration = () => {
  const [loading, setLoading] = useState(false);
  const [brandData, setBrandData] = useState({});
  const [brand, setBrand] = useState(null);
  const [role, setRole] = useState(null);
  const [username, setUserName] = useState("");
  const [registrations, setRegistrations] = useState([]);
  const [agencies, setAgencies] = useState([]);

  const history = useHistory();
  const location = useLocation();

  const loadUser = (brand) => {
    Firebase.getBrandDataByID(brand, (brand_data) => {
      if (brand_data) {
        setBrandData(brand_data);
        Firebase.getRegistrationsByBrand(brand_data.name, (data) => {
          console.log("registrations:", data);
          setRegistrations(data);
          Firebase.getAgencyByBrandID(brand, (res) => {
            setAgencies(
              res.filter((item) =>
                [
                  "Sales manager",
                  "Account manager",
                  "Sales rep",
                  "Service manager",
                  "Service rep",
                ].includes(item.type)
              )
            );
            setLoading(false);
          });
        });
      }
    });
  };

  useEffect(() => {
    if (!location.state) {
      history.push("/");
    } else {
      const { brand, role, username } = location.state;
      setRole(role);
      setBrand(brand);
      setLoading(true);
      setUserName(username);

      loadUser(brand);
    }
  }, [location]);

  return (
    <div id="page-container">
      {loading && (
        <div className="loading_gif">
          <i className="fa fa-3x fa-sync fa-spin text-muted" />
        </div>
      )}
      <Header
        username={username}
        role={role}
        logo={brandData.logo}
        brand={brand}
        brandName={brandData.name}
        is_property_brand={brandData.is_property_brand}
      />
      <div className="registration-content">
        <div className="table-header">
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={2}>
              <p>Date</p>
            </Grid>
            <Grid item xs={4}>
              <p>Registered prospect name</p>
            </Grid>
            <Grid item xs={3}>
              <p>Converted to member</p>
            </Grid>
            <Grid item xs={3}>
              <p>Sales or Service manager</p>
            </Grid>
          </Grid>
        </div>
        {registrations.map((user) => {
          return (
            <div className="table-content">
              <Grid container spacing={3} alignItems="center">
                <Grid item xs={2}>
                  <p>
                    {brandData.territory === "USA"
                      ? moment(user.register_date).format("MM/DD/YYYY")
                      : moment(user.register_date).format("DD.MM.YYYY")}
                  </p>
                </Grid>
                <Grid item xs={4} className="personal-info">
                  <img alt="" src={user.avatar_url || default_avatar} />
                  <p>{user.firstname}</p>
                </Grid>
                <Grid item xs={3}>
                  <p>
                    {user.user_access === "Referred prospect" ||
                    user.user_access === "Pending member" ||
                    user.user_access === "Registered prospect" ||
                    user.user_access === "Registered prospect email"
                      ? "Pending"
                      : "Converted"}
                  </p>
                </Grid>
                <Grid item xs={3}>
                  {(
                    agencies.find((agency) => agency.uid === user.accountant) ||
                    {}
                  ).username || ""}
                </Grid>
              </Grid>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CommunityRegistration;



// WEBPACK FOOTER //
// ./src/screens/CommunityRegistration/index.js